import React from "react";
import {useHistory} from "react-router-dom";
import { toast } from "react-toastify";
import CampaignCodeForm from "../../../components/CampaignCode/CampaignCodeForm";
import {addCampaignCodes} from "../../../Api/ApiCalls";
import {normalizeToUTC} from "../../../utils/SharedFunctions";

const AddCampaignCodePage = () => {
    const history = useHistory();
    const handleAddCampaign = async (formData) => {
        const requestBody = {
            code: formData.code,
            name: formData.campaign_name,
            type: formData.type,
            expiresAt: normalizeToUTC(formData.expiration_date),
            redeemAt: normalizeToUTC(formData.redeem_before_date),
        }
        try {
            await addCampaignCodes(requestBody);
            toast.success("Campaign code added successfully!");
            history.push('/campaign-codes');
        } catch (error) {
            toast.error(
                error.response?.data?.message || "Failed to add campaign code"
            );
        }
    };
    return (
        <div className="container mt-4">
            <h2 className="mb-4">Add New Campaign Code</h2>
            <CampaignCodeForm onSubmit={handleAddCampaign} />
        </div>
    );
}
export default AddCampaignCodePage;